import { render, staticRenderFns } from "./TouchClue.vue?vue&type=template&id=2df562a2&"
import script from "./TouchClue.vue?vue&type=script&lang=js&"
export * from "./TouchClue.vue?vue&type=script&lang=js&"
import style0 from "./TouchClue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports